import { jsxs, jsx } from 'react/jsx-runtime';
import * as React from 'react';
import { EGDSField } from '../../field/field/index.esm.js';
import '../../field/field-label/index.esm.js';
import '../../field/field-message/index.esm.js';
import { EGDSIcon, EGDSIconSize } from '../../icons/icon/index.esm.js';
import '../../utils/index_orig/index.esm.js';
import '../../utils/theme/theme-provider/index.esm.js';
import styles from '../../styles/uitk-egds-input.css';
import { classNames } from '../../utils/classnames/index.esm.js';
const getClassNameList = classNames.bind(styles);
class EGDSSelect extends React.Component {
  static displayName = 'EGDSSelect';
  static defaultProps = {
    emptyState: false
  };
  constructor(props) {
    super(props);
    this.state = {
      emptyStateSelection: false
    };
    this.handleChange = this.handleChange.bind(this);
  }
  handleEmptyState() {
    const {
      emptyState
    } = this.props;
    if (emptyState) {
      this.setState(() => ({
        emptyStateSelection: true
      }));
    }
  }
  handleChange = event => {
    const {
      placeholder,
      onChange,
      onBlur
    } = this.props;
    if (event.type === 'change') {
      this.handleEmptyState();
      if (onChange) {
        onChange(event);
      }
    } else if (event.type === 'blur' && onBlur) {
      onBlur(event);
    }
    if (placeholder && event.target && event.target.value !== placeholder) {
      event.target.classList.remove('uitk-field-select-placeholder');
    }
  };
  render() {
    // Black list these props from the select field
    const {
      className,
      domRef,
      label,
      hasBorder,
      hasFloatedLabel,
      hasVisibleLabel,
      icon,
      invalid,
      placeholder,
      children,
      emptyState,
      ...attributes
    } = this.props;
    const {
      id,
      disabled,
      readOnly,
      value
    } = attributes;
    const {
      emptyStateSelection
    } = this.state;
    const baseClass = 'uitk-field-select';
    const defaultValue = emptyState ? '' : placeholder;
    const fieldProps = {
      className: getClassNameList(`${baseClass}-field`, emptyState && !value && !emptyStateSelection && `${baseClass}-empty-state`),
      disabled,
      hasBorder,
      hasFloatedLabel,
      hasVisibleLabel,
      icon,
      id,
      invalid,
      label,
      placeholder: defaultValue,
      readOnly,
      required: attributes.required
    };
    const wrapperClassNames = getClassNameList(baseClass, !emptyState && placeholder && `${baseClass}-placeholder`, className);
    const iconClassNames = getClassNameList(`${baseClass}-icon`, readOnly && `${baseClass}-icon-read-only`);
    return jsxs(EGDSField, {
      ...fieldProps,
      children: [jsxs("select", {
        ...attributes,
        className: wrapperClassNames,
        "aria-describedby": invalid ? `${id}-error` : undefined,
        ref: domRef,
        defaultValue: defaultValue,
        onChange: this.handleChange,
        onBlur: this.handleChange,
        children: [(emptyState || placeholder) && jsx("option", {
          value: defaultValue,
          disabled: true,
          className: getClassNameList(`${baseClass}-dummy-option`),
          "aria-selected": "false",
          children: defaultValue
        }), children]
      }), jsx(EGDSIcon, {
        name: "expand_more",
        className: iconClassNames,
        size: EGDSIconSize.SMALL
      })]
    });
  }
}
export { EGDSSelect };